<template>
  <div>
    <viewTable
      ref="viewTable"
      :limits="limits"
      :columns-property="columnsProperty"
      :filter="filter"
      module="basic"
      url="fm/calendarShift"
      @addOrEdit="addEditHandle"
      @delete="deleteHandle"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="班次编码">
            <el-input v-model.trim="filter.shiftCode" placeholder="请输入班次编码" clearable />
          </el-form-item>
          <el-form-item label="班次名称">
            <el-input v-model.trim="filter.shiftName" placeholder="请输入班次名称" clearable />
          </el-form-item>
          <el-form-item label="班次类型">
            <el-select v-model="filter.shiftType" placeholder="请选择班次类型" clearable>
              <el-option v-for="item in shiftTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.shiftStatus" placeholder="请选择状态" clearable>
              <el-option v-for="item in shiftStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <CalendarShiftEdit ref="calendarShiftEdit" @save-success="loadData" />
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import CalendarShiftEdit from "./CalendarShiftEdit";

export default {
  components: { viewTable, CalendarShiftEdit },
  data() {
    return {
      limits: {
        addAuth: this.$auth(158),
        editAuth: this.$auth(159),
        delAuth: this.$auth(160),
      },
      shiftTypeOptions: [
        { label: "白班", value: 1 },
        { label: "中班", value: 2 },
        { label: "晚班", value: 3 },
        { label: "混合多班", value: 4 },
      ],
      shiftStatusOptions: [
        { label: "禁用", value: 0 },
        { label: "启用", value: 1 },
      ],
      filter: {
        shiftCode: "",
        shiftName: "",
        shiftType: null,
        shiftStatus: null,
      },
      columnsProperty: [
        { tooltip: true, key: "shiftCode", width: 130, align: "center" },
        { tooltip: true, key: "shiftName", minWidth: 150 },
        { tooltip: true, key: "shiftType", width: 100, align: "center" },
        { tooltip: true, key: "effectWorkHour", width: 120, align: "right" },
        { tooltip: true, key: "shiftStatus", width: 80, align: "center" },
        { key: "action", align: "center", width: 100, slot: "action" },
      ],
    };
  },
  methods: {
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },
    addEditHandle(row) {
      this.$refs.calendarShiftEdit.open(row);
    },
    deleteHandle(row) {
      this.$http.delete("basic", "fm/calendarShift", row.id).then((resp) => {
        if (resp.success) {
          this.$message.success("删除成功");
          this.loadData();
        }
      });
    },
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
